import { Dispatch, FC } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Action } from 'redux';

import { logout as serviceLogout } from '../../lib/store/common-actions';

import IconBack from '../../assets/img/icon-arrow_back.svg';
import IconCloseWhite from '../../assets/img/icon-close-white.svg';
import { useIsMobile } from '../../hooks';
import { UI_ROUTES } from '../../util/routes';
import { ClickableImage, HeaderLogo } from '../index';

import styles from './LogoAndCloseButton.module.scss';

type Props = {
  onBackBtnPress?: Function;
  displayBackButton: boolean;
  displayCloseButton: boolean;
} & ReduxProps

const LogoAndCloseButton: FC<Props> = (props: Props): JSX.Element => {
  const { onBackBtnPress, displayCloseButton, displayBackButton, logout } = props;
  const navigate = useNavigate();
  const { isMobile } = useIsMobile();

  const handleLogout = () => {
    logout();
    navigate(UI_ROUTES.signUp);
  };

  if (isMobile) {
    return displayBackButton ? (
      <ClickableImage
        alt=""
        src={IconBack}
        className={styles.backIcon}
        onClick={() => (onBackBtnPress ? onBackBtnPress() : navigate(-1))}
      />
    ) : <></>;
  }

  return (
    <>
      <HeaderLogo className={styles.logoCapital} />
      {displayCloseButton && (
        <ClickableImage
          alt=""
          src={IconCloseWhite}
          className={styles.closeIcon}
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        />
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  logout: () => dispatch(serviceLogout()),
});

const connector = connect(null, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(LogoAndCloseButton);
